export default __webpack_public_path__ + "static/junsung.yoon-9a7a61f4e38c7c46ee94d2c8d6839de1.png";